(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.SSR",
            {
                url: "/SSR",
                component: "ssr",
                PageTitle: "Social Security Resources",
                requiredPermissions: "SocialSecurityResources:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("ssr",
    {
        templateUrl: "App/Resources/SSR/SSR.html",
        controller: ssrCtrl,
        bindings: {
            states: "<"
        }
    });

    ssrCtrl.$inject = ["$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "wistiaApi", "permissionService", "amplitudeService"];


    function ssrCtrl($filter, eligibilityFormDialog, surveys, eligibilityFormApi, wistiaApi, permissionService, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.socialSecurityResourcesId).then(function (response) {
                $ctrl.submitted = response;
            });
        });        

        $ctrl.loadResources = function () {
            
            $ctrl.loadingAssets = true;

            wistiaApi.getSocialSecurityResourceAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);                                    
        }

        $ctrl.closeOtherAssets = function (asset) {

            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        }

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.socialSecurityResourcesId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        if (permissionService.hasOnePermission("SocialSecurityResources:Access")) {
            $ctrl.loadResources();
        }        
    }
})(window.app, window.angular); // jshint ignore:line